import {Injectable} from '@angular/core';
import {Store} from '@ngrx/store';
import {Observable, tap} from 'rxjs';
import {Taxonomy} from './taxonomy.reducer';
import {selectFilteredTaxonomies, selectTaxonomies} from './taxonomy.selectors';
import {
  createTaxonomy,
  deleteTaxonomy,
  loadTaxonomies,
  loadTaxonomiesByFilter,
  updateTaxonomy
} from './taxonomy.actions';
import {distinctUntilChanged} from 'rxjs/operators';
import {TaxonomyFilterModel} from './taxonomy-filters/taxonomy-filters.component';

export interface CreateUpdateTaxonomy {
  name: string,
  parentId?: number;
}


@Injectable({
  providedIn: 'root'
})
export class TaxonomyFacadeService {

  constructor(private store: Store) {
  }

  getAll(): Observable<Taxonomy[]> {
    return this.store.select(selectTaxonomies)
      .pipe(
        distinctUntilChanged(),
        tap(taxonomies => {
          if (!taxonomies || taxonomies.length === 0) {
            this.loadAll();
          }
        })
      );
  }

  getByFilter(): Observable<Taxonomy[]> {
    return this.store.select(selectFilteredTaxonomies);
  }

  loadAll() {
    this.store.dispatch(loadTaxonomies());
  }

  loadByFilter(filter: TaxonomyFilterModel) {
    this.store.dispatch(loadTaxonomiesByFilter({filter}));
  }

  create(model: CreateUpdateTaxonomy) {
    this.store.dispatch(createTaxonomy({model}));
  };

  update(id: number, model: CreateUpdateTaxonomy) {
    this.store.dispatch(updateTaxonomy({model, id}));
  };

  delete(id: number) {
    this.store.dispatch(deleteTaxonomy({id}));
  };
}
